/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Group_By_Timecode_LabelInputs */

const en_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Events by Timecode`)
};

const fr_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grouper les evenements par timecode`)
};

const de_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse nach Zeitcode gruppieren`)
};

const it_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi di gruppo per codice temporale`)
};

const ru_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Групповые мероприятия по временным меткам`)
};

const es_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos grupales por código de tiempo`)
};

const zh_cn2_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间码分组事件`)
};

const ja_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードによるイベントのグループ化`)
};

const hi_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड के अनुसार इवेंट्स को ग्रुप करें`)
};

const pt_pt2_transcript_export_group_by_timecode_label = /** @type {(inputs: Transcript_Export_Group_By_Timecode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos em grupo por código de tempo`)
};

/**
* | output |
* | --- |
* | "Group Events by Timecode" |
*
* @param {Transcript_Export_Group_By_Timecode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_group_by_timecode_label = /** @type {((inputs?: Transcript_Export_Group_By_Timecode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Group_By_Timecode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_group_by_timecode_label(inputs)
	if (locale === "de") return de_transcript_export_group_by_timecode_label(inputs)
	if (locale === "it") return it_transcript_export_group_by_timecode_label(inputs)
	if (locale === "ru") return ru_transcript_export_group_by_timecode_label(inputs)
	if (locale === "es") return es_transcript_export_group_by_timecode_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_group_by_timecode_label(inputs)
	if (locale === "ja") return ja_transcript_export_group_by_timecode_label(inputs)
	if (locale === "hi") return hi_transcript_export_group_by_timecode_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_group_by_timecode_label(inputs)
	return en_transcript_export_group_by_timecode_label(inputs)
});